import { Typography } from "@mui/material";
import { fData } from "src/utils/formatNumber";

export default () => (
  <Typography
      variant="caption"
      sx={{
        mt: 2,
        mx: 'auto',
        display: 'block',
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      Erlaubt *.jpeg, *.jpg, *.png, *.gif
      <br /> mit maximaler Größe von {fData(3145728)}
    </Typography>
  );